define(
    'views/reputation.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/reputation_form.html',
        'text!templates/remove_reputation.html'
    ],
    function(Loader, Config, Helper, Sandbox, reputationTemplate, removeTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var ReputationView = Loader.Backbone.View.extend(
            {

                data: {
                    type: null,
                    userId: null,
                    userLogin: null,
                    postId: null
                },

                events: Helper.prepareEventsForDevice(
                    {
                        'click li.pa-respect a[href*="relation.php"]': 'showForm',
                        'click .post-vote a[href*="relation.php"]': 'showForm',
                        'click .post_reputation.bg': 'hideForm',
                        'click #reputationButtonSend': 'sendReputation',
                        'click #reputationButtonCancel': 'hideForm',
                        'click .removeReputation': 'removeReputation'
                    },
                    Loader.eventType
                ),

                routes: {
                    "/viewtopic.php": "prepareReputationsButtons prepareReputationForm",
                    "/respect.php": "showRespectMessages",
                    "/positive.php": "showPositiveMessages"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');
                    var user =  this.model.get('users').getMe();

                    this.model.on('startApplication', function(){
                        if (Config.modules.reputation.enabled)
                            Helper.filterRoutes(_this.routes, _this);
                    });
                },

                render: function()
                {
                    var elem = $("#pun-reputation");

                    var compiledTemplate = _.template(
                        reputationTemplate,
                        {
                            model: this.model.toJSON(),
                            data: this.data
                        }
                    );

                    elem.html(compiledTemplate);
                    return this;
                },

                prepareReputationForm: function()
                {
                    // отключение ajax-репутации
                    $('div.post-vote,li.pa-respect').find('a[href*="relation.php?"]').each(function() {
                        $(this).data('clickHandler', $.cache[this[$.expando]].events['click'][0].handler)
                    })
                        .unbind('click');

                    var elem = $("div.linksb");
                    elem.after('<div id="pun-reputation"></div>');
                    this.render();
                },

                prepareReputationsButtons: function()
                {
                    $("li.pa-respect a:[href*='respect.php']")
                        .html("Репутация");

                    $("img[src='img/plus.png']")
                        .attr({src:'//i.rusff.ru/f/ru/rusff/r_add.gif'});

                    $("img[src='img/minus.png']")
                        .attr({src:'//i.rusff.ru/f/ru/rusff/r_minus.gif'});
                },

                showForm: function(e)
                {
                    e && e.preventDefault();
                    var elem = $(e.currentTarget);

                    var type = $(elem).attr('href').indexOf('&v=1') !=-1 ? 1 : 0;
                    var id = $(elem).parents('.post').find('li.pa-respect').find('a[href*="respect.php"]').attr('href');
                    id = id.substring(id.indexOf("id=")+3);
                    var login = $(elem).parents('.post').find('li.pa-author a').text();
                    var post_id = $(elem).attr("href").substring($(elem).attr("href").indexOf("?id=")+4, $(elem).attr("href").indexOf("&"));
                    var href = $(elem).attr("href");

                    this.data.type = type;
                    this.data.userId = id;
                    this.data.userLogin = login;
                    this.data.postId = post_id;
                    this.data.href = href;

                    this.render();
                    $('div.post_reputation').fadeIn('fast');
                },

                hideForm: function(e)
                {
                    e && e.preventDefault();
                    $('div.post_reputation').fadeOut('fast');
                },

                sendReputation: function(e)
                {
                    var _this = this;
                    var text = $('#reputationText').val();
                    var $button = $(e.currentTarget);
                    var callback = function() {
                        var selector = ".post-vote a[href='" + _this.data.href + "']";
                        var element = $(selector);
                        var post = element.parents('.post').clone();
                        post.find(selector).click(element.data('clickHandler')).trigger('click');
                        $('div.post_reputation').fadeOut('fast');
                    };

                    e.preventDefault();

                    $button.attr('disabled', true);
                    $button.val('Изменяю...');

                    // if (text.length == 0) {
                    //     callback();
                    //     return;
                    // }

                    this.model.get('reputation').sendReputation({
                        message: text,
                        postId: _this.data.postId,
                        topicName: FORUM.get('topic.subject'),
                        userId: _this.data.userId,
                        type: _this.data.type
                    }, callback, function(){
                        alert('Произошла ошибка при изменении репутации! Попробуйте позже.');
                        _this.hideForm(e);
                        $button.attr('disabled', false);
                        $button.val('Изменить');
                    });
                },

                showPositiveMessages: function(e)
                {
                    this.showMessages(e, 'positive');
                },

                showRespectMessages: function(e)
                {
                    this.showMessages(e, 'respect');
                },

                showMessages: function(e, type)
                {
                    var list = [];
                    $('div#pun-main table thead th.tcr')
                        .before('<th class="tc3" scope="col">За что</th>');

                    $('div#pun-main table tbody td.tcr')
                        .before('<td class="tc3" scope="col"> — </td>');

                    $('div#pun-main table tbody tr').each(function(){
                        var tc3 = $(this).find('td.tc3 a');
                        var tcr = $(this).find('td.tcr a');

                        var userId = tc3.attr('href').substring(tc3.attr('href').indexOf('?id=')+4);
                        var postId = tcr.attr('href').substring(tcr.attr('href').indexOf('?pid=')+5, tcr.attr('href').indexOf('#'));

                        if (type == 'respect') {
                            list.push({
                                from: userId,
                                to: Helper.getParam('id'),
                                post_id: postId
                            });
                        }
                        else {
                            list.push({
                                from: Helper.getParam('id'),
                                to: userId,
                                post_id: postId
                            });
                        }
                    });

                    var user =  this.model.get('users').getMe();

                    this.model.get('reputation').getReputation(list, function(result){
                        if (result.length) {
                            $('div#pun-main table tbody tr').each(function(i){
                                if (result[i] != null) {
                                    var message = result[i].message;
                                    if (message) {
                                        message = Helper.htmlspecialchars(result[i].message);

                                        if(user.get('groupId') == 1) {
                                            var compiledTemplate = _.template(
                                                removeTemplate,
                                                {
                                                    from: result[i].from,
                                                    to: result[i].to,
                                                    postId: result[i].post_id,
                                                }
                                            );
                                            message = compiledTemplate + message;
                                        }
                                    } else {
                                        message = ' — ';
                                    }
                                    $('div#pun-main table tbody tr:eq('+i+') td.tc3:last').html(message);
                                }
                            });
                        }
                    });
                },

                removeReputation: function(e)
                {
                    var elem = $(e.currentTarget);

                    var dataToSend = {
                        from_id: elem.attr('data-from'),
                        to_id: elem.attr('data-to'),
                        post_id: elem.attr('data-pid')
                    };

                    this.model.get('reputation').removeReputation(dataToSend, function(result){
                        location.reload(true);
                    });
                }
            });

        return {
            initialize: function(model)
            {
                if (Config.modules.reputation.enabled === false) {
                    return;
                }
                return new ReputationView({
                    el: $("#pun-main"),
                    model: model
                })
            }
        }
    }
);


